import React from 'react';

import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import {
  ButtonPrimary,
  ButtonTertiary,
} from '@spotify-internal/encore-creator-web';

import { useCurrentArtistIdOrNull } from '../../../../artists';

import type { Editable } from '../types';
import type { FundraisingLocationState } from '../../types';

const Box = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export function ArtistFundraisingPickUpdateFooter(props: Editable) {
  const currentArtistId = useCurrentArtistIdOrNull();

  const history = useHistory<FundraisingLocationState>();

  if (!props.isEditing) return null;

  function onCancel() {
    props.setIsEditing(false);
  }

  function onEditLink(e: React.MouseEvent) {
    if (currentArtistId) {
      history.push(`/artist/${currentArtistId}/profile/fundraising`, {
        isFundraisingFormEditMode: true,
      });
    }
    e.preventDefault();
  }

  return (
    <Box>
      <ButtonTertiary onClick={onCancel}>cancel</ButtonTertiary>
      <ButtonPrimary onClick={onEditLink}>edit link</ButtonPrimary>
    </Box>
  );
}
